var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.375 16.75V3.20833L19.875 1.125V14.6667M7.375 16.75C7.375 18.4759 5.97589 19.875 4.25 19.875C2.52411 19.875 1.125 18.4759 1.125 16.75C1.125 15.0241 2.52411 13.625 4.25 13.625C5.97589 13.625 7.375 15.0241 7.375 16.75ZM19.875 14.6667C19.875 16.3926 18.4759 17.7917 16.75 17.7917C15.0241 17.7917 13.625 16.3926 13.625 14.6667C13.625 12.9408 15.0241 11.5417 16.75 11.5417C18.4759 11.5417 19.875 12.9408 19.875 14.6667Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSong);
export default __webpack_public_path__ + "static/media/song.b317e70061cd6ba3aef300b053c40689.svg";
export { ForwardRef as ReactComponent };